var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38269 1.26834L1.30722 9.23084C0.859392 9.67241 0.600298 10.2676 0.583693 10.892L0.500174 14.1953C0.492487 14.4994 0.740346 14.7499 1.04878 14.7499H4.36901C5.02506 14.7499 5.65359 14.4934 6.11717 14.0363L14.2245 6.04241C15.2635 5.01796 15.2635 3.35633 14.2245 2.33188L13.1459 1.26834C12.1069 0.243886 10.4217 0.243886 9.38269 1.26834ZM12.3701 2.03341L13.4487 3.09695C14.0591 3.69877 14.0591 4.67519 13.4487 5.27701L12.8219 5.89505L9.53192 2.65179L10.1591 2.03341C10.7694 1.43159 11.7597 1.43159 12.3701 2.03341ZM8.75583 3.41702L2.08361 9.99591C1.83468 10.2414 1.69041 10.5728 1.68119 10.9195L1.6115 13.6672L4.36931 13.6675C4.69381 13.6675 5.00588 13.5549 5.25219 13.3514L5.34137 13.2709L12.0458 6.66028L8.75583 3.41702Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.23814cac62e0a4d9dbf18222df315584.svg";
export { ForwardRef as ReactComponent };